import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';
import Productos from './ViewModal/Productos';

import FormaPago from './ViewModal/FormaPago';


import Footer from './ViewModal/Footer';

const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class ViewModal extends React.Component {
    render() {

 /*        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator("idFormaPago", {
            initialValue: this.props.formValues.idFormaPago,
          }); */

        return (
            <Modal
                title={"Detalle de Cuotas"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>
                ]}
            >
                <Form>

                    
                <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Documento">
                            <Input readOnly
                                    value={this.props.formValues.DocumentoCliente}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-8">
                            <Form.Item label="Cliente">
                                <Input readOnly
                                    value={this.props.formValues.RazonSocialClientemento}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.FechaTipoCambio}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    />
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.TipoCambio}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '40%' }}
                                        value={this.props.formValues.Serie}
                                    />
                                    <Input readOnly
                                        style={{ width: '60%' }}
                                        value={this.props.formValues.Correlativo}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Días / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.Dias}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.FechaVencimiento}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Moneda">
                                <Input readOnly
                                    value={this.props.formValues.Moneda}
                                />
                            </Form.Item>
                        </div>
                    </div>
        
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Factura">
                            <Input readOnly
                                    value={this.props.formValues.NumeroDocumento}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-8">
                      
                        </div>
                    </div>

             
                    <div className="row">
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <Productos
                                        dataSource={this.props.formValues.detalles} onViewPago={this.props.onViewPago}                                         
                                    />
                                </TabPane>

                        </Tabs>  
                        </div>
                    </div>
                    <Footer
                        formValues={this.props.formValues}
                    />
                </Form>
            </Modal>
        );
    }
}